import { render, staticRenderFns } from "./DocumentActionModal.vue?vue&type=template&id=4995b676&scoped=true&"
import script from "./DocumentActionModal.vue?vue&type=script&lang=js&"
export * from "./DocumentActionModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentActionModal.vue?vue&type=style&index=0&id=4995b676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4995b676",
  null
  
)

export default component.exports